import React from "react";
import PropTypes from "prop-types";


const editIcon = () => (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M.015 11.25L0 14.335c0 .174.06.349.178.475.118.127.266.19.429.19l2.87-.016c.164 0 .312-.063.43-.19l9.915-10.601a.702.702 0 0 0 0-.934L10.981.19a.597.597 0 0 0-.873 0L8.125 2.327.192 10.79a.73.73 0 0 0-.177.459zm10.537-9.668l1.998 2.136-1.125 1.203-1.998-2.136 1.125-1.203zm-9.309 9.953l7.31-7.817 1.999 2.136-7.311 7.801-2.013.016.015-2.136zM17.358 17c.351 0 .642.232.642.5s-.275.5-.627.5H.627C.291 18 0 17.768 0 17.5s.275-.5.627-.5h16.73z"
            fill="#008755"
            fillRule="nonzero"
        />
    </svg>
);

const Icon = props => {
    // prettier-ignore
    switch (props.src) {
        case "editIcon" : return editIcon(); 
	  default:
        return (<svg></svg>);
	}
};

export default Icon;

// props validation
Icon.propTypes = {
    src: PropTypes.string.isRequired
};
